<div class="content">
    <div class="controls" *ngIf="isAuthenticated">
        <div class="control-group">
            <label for="wellSelect">Select Well:</label>
            <select 
                id="wellSelect"
                [(ngModel)]="activeWell" 
                (ngModelChange)="onWellChange()"
                class="form-select">
                <option value="">-- Select Well --</option>
                <option *ngFor="let well of wells" [value]="well.name || well">
                    {{ well.display_name || well.name || well }}
                </option>
            </select>
        </div>
        
        <div class="control-group" *ngIf="schemas.length > 0">
            <label for="schemaSelect">Select Schema:</label>
            <select 
                id="schemaSelect"
                [(ngModel)]="activeSchema" 
                (ngModelChange)="onSchemaChange()"
                class="form-select">
                <option value="">-- Select Schema --</option>
                <option *ngFor="let schema of schemas" [value]="schema.name || schema">
                    {{ schema.name || schema }}
                </option>
            </select>
        </div>
    </div>

    <div class="authentication-status" *ngIf="!isAuthenticated && !isLoading">
        <p>Authentication with Wells API is required to view data.</p>
        <button (click)="authenticateWithWellsAPI()">Retry Authentication</button>
    </div>

    <div class="data" *ngIf="isAuthenticated">
        <!-- Simple Add Record Button -->
        <button 
            class="standalone-add-button" 
            (click)="addEmptyRecord()" 
            *ngIf="data && data.length > 0">
            ➕ Add New Record
        </button>
        
        <sdk-datagrid
            title="Wells Schema Data"
            titleStyle="font-family: 'GothamBold', sans-serif; color: var(--blue-dark); font-size: 1.5em; font-weight: unset; text-align: center;"
            fontFamily="'GothamNarrowBook', sans-serif, 'Helvetica Neue', Arial"
            columnHeaderStyle="font-family: 'GothamBold', sans-serif; color: var(--blue-dark); font-size: 0.9em; font-weight: unset;"
            [(updateGrid)]="updateGrid"
            [(columns)]="columns"
            [(dataExport)]="dataExport"
            [options]="options"
            [data]="data"
            [rows]="rows"
            [page]="page"
            [total]="total"
            [error]="error"
            [isDebug]="false"
            (selectedRowActionEvent)="showDetails($event)"
            (loadDataEvent)="loadData($event)">
        </sdk-datagrid>
    </div>

    <sdk-loading [isLoading]="isLoading"></sdk-loading>
</div>
